import { memo } from "react";

export const Header = memo(() => {
  return <p>へっだー</p>;
});